<template>
  <div
    id="orderManage"
    :thirdNavigationState="thirdNavigationState"
    :thirdNavigationType="thirdNavigationType"
    :thirdNavigationIdentify="thirdNavigationIdentify"
    :thirdNavigationSearch="thirdNavigationSearch"
  >
    <el-main>
      <el-table
        ref="dataTable"
        v-loading="loading"
        :data="orderTableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        @row-click="rowClick"
        :row-style="{ height:'90px!important;' }"
        style="width: 100%"
      >
        <el-table-column
          :default-sort="{prop: 'miboStoreOrderId', order: 'descending'}"
          sortable
          :label="$t('orderManagment.table.header.id')"
          width="170px;"
          prop="miboStoreOrderId"
        ></el-table-column>

        <el-table-column width="60px;">
          <template slot-scope="scope">
            <img :src="scope.row.icon" alt class="tableIconClass">
          </template>
        </el-table-column>

        <el-table-column
          width="217px;"
          :default-sort="{prop: 'title', order: 'descending'}"
          sortable
          :label="$t('table.common.projectName')"
          prop="projectName"
        ></el-table-column>

        <el-table-column
          :default-sort="{prop: 'contentType', order: 'descending'}"
          sortable
          :label="$t('table.common.projectType')"
          prop="contentType"
        ></el-table-column>

        <el-table-column
          width="106px;"
          :default-sort="{prop: 'price', order: 'descending'}"
          sortable
          :label="$t('orderManagment.table.header.price')"
          prop="price"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.currency === 'RMB' ">￥{{scope.row.price}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :default-sort="{prop: 'status', order: 'ascending'}"
          sortable
          :label="$t('orderManagment.table.header.status')"
          prop="status"
        >
          <template slot-scope="scope">
            <span :class=" tableCellStyle(scope) ">{{ tableCellText(scope) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="168px;"
          :default-sort="{prop: 'updatedAt', order: 'descending'}"
          sortable
          :label="$t('orderManagment.table.header.update')"
          prop="updatedAt"
        >
          <template slot-scope="scope">
            <span>{{timeTransform(scope.row.updatedAt)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </div>
</template>
<script>
import moment from 'moment'
export default {
    data () {
        return {
            loading: false,
            orderTableData: [],
            search: '',
            paidStatus: [
                { status: 'paid', text: '付款成功', style: 'tableStatusPaid' },
                {
                    status: 'failed',
                    text: '付款失败',
                    style: 'tableStatusUnpaid'
                },
                {
                    status: 'partially refunded',
                    text: '部分退款',
                    style: 'tableStatusUnpaid'
                },
                {
                    status: 'pending',
                    text: '等候付款',
                    style: 'tableStatusWaitpaid'
                }
            ]
        }
    },
    created () {
        this.getOrderData()
    },
    methods: {
        isScrollShowFunc (len) {
            if (len > 8) {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.add('scrollShow')
            } else {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.remove('scrollShow')
            }
        },
        // 订单信息
        getOrderData (key, val, type) {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.loading = true
            let path
            if (key) {
                path = `/developer/order?${key}=${val}`
            } else {
                path = `/developer/order`
            }
            key === 'keyword' && this.clearState(key)
            this._api.request('get', path)
                .then(res => {
                    this.orderTableData = res.data.data.payload
                    let len = this.orderTableData.length
                    this.isScrollShowFunc(len)
                    this.$store.state.orderSumAll = len
                    if (type === 'filter') {
                        this.filterStateType(
                            this.thirdNavigationState,
                            this.thirdNavigationType
                        )
                    }
                    this.loading = false
                })
                .catch(error => {
                    console.log(error)
                })
        },
        // 对data不同的filter
        clickFunc (type, val) {
            if (type === 'contentType') {
                this.getOrderData(type, val)
            } else if (type === 'orderStatus') {
                this.getOrderData(type, val)
            } else {
                this.getOrderData(type, val)
            }
        },
        // 操作表头
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            let style = `
                        height: 40px!important;
                        box-sizing: border-box;
                        letter-spacing: 0.8px;
                        color: #333333;
                        font-family: sans-serif;
                        font-size: 14px;
                        line-height: 40px;
                        background:rgba(51, 51, 51, 0.08);
                        `
            let padding
            if (columnIndex === 0) {
                padding = 'padding:0px 17px 0px 14px!important;'
                return `
               ${style}
               ${padding}
            `
            } else if (columnIndex === 2) {
                padding = 'padding: 0px 19px 0px 31px!important;'
                return `
               ${style}
               ${padding}
            `
            } else if (columnIndex === 4) {
                padding = 'padding: 0px 14px 0px 17px!important;'
                return `
               ${style}
               ${padding}
            `
            } else if (columnIndex === 6) {
                padding = 'padding: 0px 0px 0px 19px!important;'
                return `
               ${style}
               ${padding}
            `
            } else {
                return `
               ${style}
            `
            }
        },
        // 操作表行
        cellStyle ({ row, column, rowIndex, columnIndex }) {
            let style = `
                height: 90px!important;
                box-sizing: border-box;
                letter-spacing: 0.8px;
                color: #333333;
                font-family: sans-serif;
                font-size: 14px;
                font-weight: 300;
                line-height: 90px!important;
                `
            let padding
            if (columnIndex === 0) {
                padding = 'padding:0px 17px 0px 14px!important;'
                return `
                    ${style}
                    ${padding}
                  `
            } else if (columnIndex === 2) {
                padding = 'padding: 0px 19px 0px 31px!important;'
                return `
                    ${style}
                    ${padding}
                  `
            } else if (columnIndex === 4) {
                padding = 'padding: 0px 14px 0px 17px!important;'
                return `
                    ${style}
                    ${padding}
                  `
            } else if (columnIndex === 6) {
                padding = 'padding: 0px 10px 0px 24px!important;'
                return `
                    ${style}
                    ${padding}
                  `
            } else {
                return `
                    ${style}
                  `
            }
        },
        rowClick () {},
        renderHeader (h, { column, $index }) {},
        // 时间
        timeTransform (date) {
            return moment(date).format('YYYY-MM-DD')
        },
        clearState (type) {
            if (type) {
                this.$store.state.thirdNavigationType = null
                this.$store.state.thirdNavigationState = null
            }
            this.$store.state.thirdNavigationIdentify = null
        },
        filterStateType (state, type) {
            this.orderTableData = this.orderTableData.filter(item => {
                return item.contentType === type && item.status === state
            })
            let len = this.orderTableData.length
            this.isScrollShowFunc(len)
            this.$store.state.orderSumAll = this.orderTableData.length
        },
        tableCellStyle ({ row }) {
            return this.paidStatus.filter(item => item.status === row.status)[0]
                .style
        },
        tableCellText ({ row }) {
            return this.paidStatus.filter(item => item.status === row.status)[0]
                .text
        }
    },
    computed: {
        thirdNavigationState () {
            return this.$store.state.thirdNavigationState
        },
        thirdNavigationType () {
            return this.$store.state.thirdNavigationType
        },
        thirdNavigationIdentify () {
            let type = this.$store.state.thirdNavigationIdentify
            if (
                type &&
                this.$store.state.isFlagSpanClass === 'orderManagment'
            ) {
                if (type === 'search') {
                    this.thirdNavigationSearch &&
                        this.clickFunc('keyword', this.thirdNavigationSearch)
                    !this.thirdNavigationSearch && this.getOrderData()
                } else {
                    if (this.thirdNavigationState && this.thirdNavigationType) {
                        // 处理两个filter
                        this.getOrderData(null, null, 'filter')
                    } else if (
                        this.thirdNavigationType &&
                        !this.thirdNavigationState
                    ) {
                        this.clickFunc('contentType', this.thirdNavigationType)
                    } else if (
                        this.thirdNavigationState &&
                        !this.thirdNavigationType
                    ) {
                        this.clickFunc('orderStatus', this.thirdNavigationState)
                    } else {
                        this.getOrderData()
                    }
                }
                this.clearState()
            }
            return this.$store.state.thirdNavigationIdentify
        },
        thirdNavigationSearch () {
            return this.$store.state.thirdNavigationSearch
        }
    },
    destroyed () {
        this.clearState('destroyed')
    }
}
</script>
<style scoped>
._div span {
    margin-right: 20px;
}
.tableIconClass {
    cursor: pointer;
    width: 60px;
    height: 60px;
    padding: 15px 0px;
    vertical-align: middle;
    display: inline-block;
}
.tableStatusPaid {
    display: inline-block;
    width: 75px;
    height: 25px;
    line-height: 25px;
    border: 1px solid #00b5e2;
    border-radius: 4px;
    background-color: rgba(0, 181, 226, 0.1);
    color: #00b5e2;
    text-align: center;
}
.tableStatusUnpaid {
    display: inline-block;
    width: 75px;
    height: 25px;
    line-height: 25px;
    border: 1px solid #ffc44f;
    border-radius: 4px;
    background-color: rgba(255, 196, 79, 0.1);
    color: #ffc44f;
    text-align: center;
}
.tableStatusWaitpaid {
    display: inline-block;
    width: 75px;
    height: 25px;
    line-height: 25px;
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 4px;
    background-color: rgba(51, 51, 51, 0.1);
    color: #333333;
    text-align: center;
}
#orderManage {
    padding: 193px 0px 38px 0px;
    background-color: rgba(51, 51, 51, 0.05);
    height: 1000px;
}
</style>
<style>
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
#orderManage ::-webkit-scrollbar {
    width: 10px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
#orderManage ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    background-color: rgba(51, 51, 51, 0.2);
    border-radius: 3px;
}
/*定义滑块颜色、内阴影及圆角*/
#orderManage ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.8);
}
#orderManage .scrollShow {
    overflow-y: scroll !important;
    height: 800px;
    overflow-x: hidden !important;
}
#orderManage .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 224, 218, 0.05) !important;
}
#orderManage .el-table .cell {
    padding: 0px;
    line-height: 40px;
}
#orderManage .el-table tr:last-child > td {
    border-bottom: none !important;
}
#orderManage .el-main {
    padding: 0px;
    width: 896px;
    margin: auto;
}
#orderManage .el-table__header th {
    padding: 0px !important;
}
#orderManage .el-table__body {
    border-radius: 2px;
    border-bottom: none;
}
#orderManage .el-table__header {
    border-bottom: 1px solid rgba(51, 51, 51, 0.2);
    background: rgba(51, 51, 51, 0.1);
}
#orderManage .el-table--fit {
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}
</style>
